import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "folders-head" }
const _hoisted_3 = {
  class: "orgteam-bar",
  style: {"margin":"0"}
}
const _hoisted_4 = {
  key: 0,
  class: "folders-desc"
}
const _hoisted_5 = {
  key: 1,
  class: "folders-desc"
}
const _hoisted_6 = {
  key: 2,
  class: "full-table folders-table"
}
const _hoisted_7 = {
  key: 0,
  class: "folders-section-row"
}
const _hoisted_8 = { colspan: "4" }
const _hoisted_9 = {
  key: 1,
  class: "folder-add-row"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "folder-name" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "folder-chev-spacer"
}
const _hoisted_16 = { class: "folder-icon" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 5,
  class: "folder-tag is-status"
}
const _hoisted_20 = {
  key: 6,
  class: "folder-tag",
  title: "This folder links back to one of the folders above it"
}
const _hoisted_21 = {
  key: 1,
  class: "folder-muted"
}
const _hoisted_22 = {
  key: 1,
  class: "folder-muted"
}
const _hoisted_23 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_24 = { class: "row-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "row-menu-dropdown"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  style: {"padding":"0"}
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 3,
  class: "folder-tree"
}
const _hoisted_37 = {
  key: 0,
  class: "folder-tree-section"
}
const _hoisted_38 = { class: "folder-icon" }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 2,
  class: "folder-tag"
}
const _hoisted_41 = {
  key: 3,
  class: "folder-tag is-status"
}
const _hoisted_42 = {
  key: 4,
  class: "folder-tag",
  title: "This folder links back to one of the folders above it"
}
const _hoisted_43 = {
  key: 0,
  class: "folder-muted"
}
const _hoisted_44 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_45 = { class: "error-msg" }
const _hoisted_46 = { style: {"margin-bottom":"10px"} }
const _hoisted_47 = { style: {"margin-bottom":"10px"} }
const _hoisted_48 = { style: {"margin-bottom":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_edit_node = _resolveComponent("add-edit-node")!
  const _component_add_existing_node = _resolveComponent("add-existing-node")!
  const _component_add_node_to_folder = _resolveComponent("add-node-to-folder")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Folders")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["orgteam-btn", { on: _ctx.view == 'list' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setView('list')))
          }, "List", 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["orgteam-btn", { on: _ctx.view == 'tree' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setView('tree')))
          }, "Tree", 2)
        ]),
        (_ctx.canEditNodes)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "add-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNode('home', 'NODE')))
            }, "Add Folder to Home"))
          : _createCommentVNode("", true)
      ]),
      (_ctx.view == 'list')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Every folder and process belong to one or more departments, which determines who sees it. A person assigned to one of those departments will see those items."))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, "The whole structure at a glance: every folder, subfolder, and the contents inside.")),
      (_ctx.view == 'list')
        ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _cache[20] || (_cache[20] = _createElementVNode("tr", { class: "table-labels" }, [
                _createElementVNode("td", { style: {"padding-left":"42px"} }, "Name"),
                _createElementVNode("td", null, "Department"),
                _createElementVNode("td", null, "Contains"),
                _createElementVNode("td", { style: {"padding":"0"} })
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRows, (row) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: row.key
                }, [
                  (row.kind == 'section')
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _createElementVNode("td", _hoisted_8, _toDisplayString(row.label), 1)
                      ]))
                    : (row.kind == 'add')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                          _createElementVNode("td", {
                            colspan: "4",
                            style: _normalizeStyle(_ctx.indentStyle(row.depth))
                          }, [
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (_ctx.addNode(row.node.Slug, 'NODE')), ["prevent"])
                            }, "Add subfolder", 8, _hoisted_10),
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (_ctx.addNode(row.node.Slug)), ["prevent"])
                            }, "Add item", 8, _hoisted_11),
                            _createElementVNode("a", {
                              onClick: _withModifiers(($event: any) => (_ctx.addExisting(row.node)), ["prevent"])
                            }, "Add existing to " + _toDisplayString(row.node.Name), 9, _hoisted_12)
                          ], 4)
                        ]))
                      : (_openBlock(), _createElementBlock("tr", {
                          key: 2,
                          class: _normalizeClass(row.depth > 0 || row.node.Type != 'NODE' ? 'folder-row-sub' : '')
                        }, [
                          _createElementVNode("td", {
                            style: _normalizeStyle(_ctx.indentStyle(row.depth))
                          }, [
                            _createElementVNode("div", _hoisted_13, [
                              (row.canExpand)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: _normalizeClass(["folder-chev", { open: row.expanded }]),
                                    onClick: ($event: any) => (_ctx.toggle(row.key))
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "chevright" })
                                  ], 10, _hoisted_14))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15)),
                              _createElementVNode("span", _hoisted_16, [
                                _createVNode(_component_svg_icon, {
                                  icon: _ctx.typeIcon(row.node.Type)
                                }, null, 8, ["icon"])
                              ]),
                              (row.node.Type == 'NODE')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    onClick: _withModifiers(($event: any) => (row.canExpand ? _ctx.toggle(row.key) : null), ["prevent"])
                                  }, _toDisplayString(row.node.Name), 9, _hoisted_17))
                                : (row.node.Type == 'LINK')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 3,
                                      href: row.node.Link,
                                      target: "_blank"
                                    }, _toDisplayString(row.node.Name), 9, _hoisted_18))
                                  : (_openBlock(), _createBlock(_component_router_link, {
                                      key: 4,
                                      to: '/playbook/' + row.node.Slug
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.node.Name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])),
                              _createElementVNode("span", {
                                class: _normalizeClass(["folder-tag", { 'is-folder': row.node.Type == 'NODE' }])
                              }, _toDisplayString(_ctx.typeLabel(row.node.Type, row.depth)), 3),
                              (row.node.NeedsApproval)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(row.node.NeedsApprovalType || 'Needs Approval'), 1))
                                : _createCommentVNode("", true),
                              (row.isLoop)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Loop"))
                                : _createCommentVNode("", true)
                            ])
                          ], 4),
                          _createElementVNode("td", null, [
                            (row.node.Type == 'NODE' && row.depth == 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.departments(row.node), (dep) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: dep,
                                    class: "pill p-live folder-dept-pill"
                                  }, _toDisplayString(dep), 1))
                                }), 128))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.departments(row.node).join(', ')), 1))
                          ]),
                          _createElementVNode("td", null, [
                            (row.node.Type == 'NODE')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(row.depth > 0 ? 'folder-muted' : '')
                                }, _toDisplayString(_ctx.containsLabel(row.node.Slug)), 3))
                              : (_openBlock(), _createElementBlock("span", _hoisted_22, "—"))
                          ]),
                          (_ctx.canEditNodes)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "row-menu-btn",
                                    onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(row.key)), ["stop"])
                                  }, [
                                    _createVNode(_component_svg_icon, { icon: "dots" })
                                  ], 8, _hoisted_25),
                                  (_ctx.openMenuKey == row.key)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        (row.node.Type != 'LINK')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 0,
                                              to: '/playbook/' + row.node.Slug,
                                              onClick: _ctx.closeRowMenu
                                            }, {
                                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                _createTextVNode("Open", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["to", "onClick"]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.editNode(row.node))), ["prevent"])
                                        }, "Edit Details", 8, _hoisted_27),
                                        (row.node.Type == 'PROCESS')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 1,
                                              to: '/edit-process/' + row.node.Slug,
                                              onClick: _ctx.closeRowMenu
                                            }, {
                                              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                _createTextVNode("Edit Process", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["to", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (row.node.Type == 'TIMELINE')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 2,
                                              to: '/edit-timeline/' + row.node.Slug,
                                              onClick: _ctx.closeRowMenu
                                            }, {
                                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                _createTextVNode("Edit Value Engine", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["to", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (row.node.Type == 'SHEET')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 3,
                                              to: '/edit-sheet/' + row.node.Slug,
                                              onClick: _ctx.closeRowMenu
                                            }, {
                                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                _createTextVNode("Edit Sheet", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["to", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (row.node.Type == 'CHECKLIST')
                                          ? (_openBlock(), _createBlock(_component_router_link, {
                                              key: 4,
                                              to: '/edit-checklist/' + row.node.Slug,
                                              onClick: _ctx.closeRowMenu
                                            }, {
                                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                _createTextVNode("Edit Checklist", -1)
                                              ]))]),
                                              _: 1
                                            }, 8, ["to", "onClick"]))
                                          : _createCommentVNode("", true),
                                        (row.node.Type == 'NODE')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                              _createElementVNode("a", {
                                                onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.addNode(row.node.Slug, 'NODE'))), ["prevent"])
                                              }, "Add subfolder", 8, _hoisted_28),
                                              _createElementVNode("a", {
                                                onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.addNode(row.node.Slug))), ["prevent"])
                                              }, "Add item", 8, _hoisted_29),
                                              _createElementVNode("a", {
                                                onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.addExisting(row.node))), ["prevent"])
                                              }, "Add existing", 8, _hoisted_30)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.addToFolder(row.node))), ["prevent"])
                                        }, "Add to Folder", 8, _hoisted_31),
                                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "row-menu-divider" }, null, -1)),
                                        (row.parentSlug)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 6,
                                              onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.removeFromParent(row))), ["prevent"])
                                            }, "Remove from " + _toDisplayString(row.parentName), 9, _hoisted_32))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("a", {
                                          class: "row-menu-delete",
                                          onClick: _withModifiers(($event: any) => (_ctx.rowMenuAction(() => _ctx.deleteNode(row.node))), ["prevent"])
                                        }, "Delete", 8, _hoisted_33)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_34))
                        ], 2))
                ], 64))
              }), 128)),
              (!_ctx.listRows.length)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("td", {
                      colspan: "4",
                      class: "folder-muted"
                    }, "No folders yet.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treeRows, (row) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: row.key
              }, [
                (row.kind == 'section')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(row.label), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["folder-tree-row", { 'is-nested': row.depth > 0 }]),
                      style: _normalizeStyle({ marginLeft: (row.depth * 26) + 'px' })
                    }, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_svg_icon, {
                          icon: _ctx.typeIcon(row.node.Type)
                        }, null, 8, ["icon"])
                      ]),
                      (row.node.Type == 'LINK')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: row.node.Link,
                            target: "_blank"
                          }, _toDisplayString(row.node.Name), 9, _hoisted_39))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: '/playbook/' + row.node.Slug,
                            class: _normalizeClass({ 'is-folder': row.node.Type == 'NODE' })
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.node.Name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"])),
                      _createElementVNode("span", {
                        class: _normalizeClass(["folder-tag", { 'is-folder': row.node.Type == 'NODE' }])
                      }, _toDisplayString(_ctx.typeLabel(row.node.Type, row.depth)), 3),
                      (row.node.Type == 'NODE' && row.depth == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.departments(row.node).join(', ')), 1))
                        : _createCommentVNode("", true),
                      (row.node.NeedsApproval)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(row.node.NeedsApprovalType || 'Needs Approval'), 1))
                        : _createCommentVNode("", true),
                      (row.isLoop)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Loop"))
                        : _createCommentVNode("", true)
                    ], 6))
              ], 64))
            }), 128)),
            (!_ctx.treeRows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, "No folders yet."))
              : _createCommentVNode("", true)
          ]))
    ], 2),
    (_ctx.showConfirmDeleteOrDraft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _cache[22] || (_cache[22] = _createElementVNode("div", null, "Would you like to remove this item?", -1)),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.unapproveItem('Draft'))),
                class: "btn"
              }, "Yes, Move to Draft")
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.unapproveItem('Needs Approval'))),
                class: "btn"
              }, "Yes, Move to Needs Approval")
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.unapproveItem('Inactive'))),
                class: "btn"
              }, "Yes, Move to Inactive")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = () => { _ctx.showConfirmDeleteOrDraft = false; }),
                class: "btn-invert"
              }, "Cancel")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAddNode)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 1,
          type: _ctx.addType,
          fromSlug: _ctx.addFromSlug,
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeModals()))
        }, null, 8, ["type", "fromSlug"]))
      : _createCommentVNode("", true),
    (_ctx.showEditNode)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 2,
          node: _ctx.nodeToEdit,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeModals()))
        }, null, 8, ["node"]))
      : _createCommentVNode("", true),
    (_ctx.showAddExisting)
      ? (_openBlock(), _createBlock(_component_add_existing_node, {
          key: 3,
          fromSlug: _ctx.addFromSlug,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModals()))
        }, null, 8, ["fromSlug"]))
      : _createCommentVNode("", true),
    (_ctx.showAddToFolder)
      ? (_openBlock(), _createBlock(_component_add_node_to_folder, {
          key: 4,
          toSlug: _ctx.slugToAddToFolder,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeModals()))
        }, null, 8, ["toSlug"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 5,
          onConfirm: _ctx.deleteNodeConfirm,
          onCancel: _cache[11] || (_cache[11] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to PERMANENTLY DELETE this item?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmRemove)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 6,
          onConfirm: _ctx.removeFromParentConfirm,
          onCancel: _cache[12] || (_cache[12] = () => { _ctx.showConfirmRemove = false; }),
          msg: 'Are you sure you would like to remove ' + (_ctx.rowToRemove?.node.Name || 'this item') + ' from ' + (_ctx.rowToRemove?.parentName || '') + '?'
        }, null, 8, ["onConfirm", "msg"]))
      : _createCommentVNode("", true)
  ]))
}